export const BASKET_ROUTE = Object.freeze({
  overview: '1',
/*
  address: '2',
*/
  paymentMethod: '2',
});
